import { useAuth0 } from '@auth0/auth0-react'
import { Navbar, NavbarCardsProvider } from 'component-library'
import { gql, GraphQLClient } from 'graphql-request'
import { useEffect, useState } from 'react'
import { NavbarContent } from 'shared-content'
import { getCurrentEnvConfig } from '../../../config'
import { useNavbarCardsQuery } from '../../hooks/useNavbarCardsQuery'
import { useReleaseMenuCardQuery } from '../../hooks/useReleaseMenuCardQuery'
import LinkComponent from '../LinkComponent/LinkComponent'
import MarkdownText from '../MarkdownText/MarkdownText'

const config = getCurrentEnvConfig()

const GET_USER_HANDLE = gql`
  query GetUserHandle {
    me {
      handle
    }
  }
`
const graphQLClient = new GraphQLClient(config.graphql)

const NavBarWrapper = () => {
  const { isAuthenticated, loginWithRedirect, logout, getAccessTokenSilently } =
    useAuth0()
  const [userHandle, setUserHandle] = useState<string>()

  useEffect(() => {
    if (!isAuthenticated) return
    getUserHandle()
      .then((me) => setUserHandle(me.handle))
      .catch((error) => console.error(error))
  }, [isAuthenticated, getAccessTokenSilently])

  const getUserHandle = async () => {
    const token = await getAccessTokenSilently()
    const data: { me: { handle: string } } = await graphQLClient.request(
      GET_USER_HANDLE,
      {},
      { authorization: `Bearer ${token}` }
    )
    return data.me
  }

  return (
    <NavbarCardsProvider
      useCardsQuery={useNavbarCardsQuery}
      useReleaseQuery={useReleaseMenuCardQuery}
    >
      <Navbar
        isAuthenticated={isAuthenticated}
        leftItems={NavbarContent.navbarLeft}
        rightItems={NavbarContent.navbarRight}
        signInCard={NavbarContent.signInCard}
        mobileButton={NavbarContent.mobileButton}
        LinkComponent={LinkComponent}
        MarkdownText={MarkdownText}
        handle={userHandle}
        createAccount={() => {
          loginWithRedirect({
            authorizationParams: { screen_hint: 'signup' },
          })
        }}
        logIn={() => {
          loginWithRedirect({
            appState: { returnTo: window.location.pathname },
          })
        }}
        signOut={() => {
          logout({
            logoutParams: {
              returnTo:
                typeof window !== 'undefined'
                  ? `${window.location.origin}`
                  : '',
            },
          })
        }}
      />
    </NavbarCardsProvider>
  )
}

export default NavBarWrapper
